import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import styled, { ThemeProvider } from 'styled-components';
import { theme } from './styles/theme';
import Dashboard from './pages/Dashboard';

// Create a client for React Query
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
      retry: 1,
      staleTime: 30000,
    },
  },
});

/**
 * Root component for the NH Mesh Live Dashboard application.
 * Sets up global providers and renders the main Dashboard page.
 */
const App: React.FC = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <ThemeProvider theme={theme}>
        <AppContainer>
          <Dashboard />
        </AppContainer>
      </ThemeProvider>
    </QueryClientProvider>
  );
};

/**
 * Styled container for the entire application.
 * Applies global styles and ensures the app takes up the full viewport.
 */
const AppContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  background-color: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text};
  font-family: ${({ theme }) => theme.fonts.body};
`;

export default App; 